var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReferalCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 6.5C3.5 5.086 3.5 4.3785 3.9395 3.9395C4.3785 3.5 5.086 3.5 6.5 3.5H8C9.414 3.5 10.1215 3.5 10.5605 3.9395C11 4.3785 11 5.086 11 6.5V9C11 10.414 11 11.1215 10.5605 11.5605C10.1215 12 9.414 12 8 12H6.5C5.086 12 4.3785 12 3.9395 11.5605C3.5 11.1215 3.5 10.414 3.5 9V6.5Z",
    stroke: "#6D44E5",
    strokeWidth: 0.88
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 10.5C3.10218 10.5 2.72064 10.342 2.43934 10.0607C2.15804 9.77936 2 9.39782 2 9V6C2 4.1145 2 3.1715 2.586 2.586C3.1715 2 4.1145 2 6 2H8C8.39783 2 8.77936 2.15804 9.06066 2.43934C9.34197 2.72064 9.5 3.10218 9.5 3.5",
    stroke: "#6D44E5",
    strokeWidth: 0.88
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferalCopy);
export default __webpack_public_path__ + "static/media/referal_copy.0c7234094b57617dd6db41b1fde34cbf.svg";
export { ForwardRef as ReactComponent };